const endpoints = {
  // Auth
  REGISTER: "/auth/register",
  LOGIN: "/auth/login",
  FORGOT_PASSWORD: "/auth/forgot-password",

  // Blogs
  BLOGS: "/blogs",
  SINGLE_BLOG: "/blogs",

  // Contact
  CONTACT_INFO: "/contacts/info",
  CONTACT_CREATE: "/contacts/create",

  CURRENT_AFFAIRS: "/current-affairs",
};

export default endpoints;
